import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { _className, ComponentSync, LL_H_C, LL_V_L, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, scrollIntoView, stopPropagation, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { exists, Filter } from '@nu-art/ts-common';
import './SearchableListPopUp.scss';
const searchInteractionKeys = ['ArrowDown', 'ArrowUp', 'Enter'];
export class SearchableListPopUp extends ComponentSync {
    // ######################### Static #########################
    static Show = (props) => {
        const model = {
            id: props.popUpProps.id ?? 'searchable-list-popup',
            originPos: props.popUpProps.originPos,
            modalPos: props.popUpProps.modalPos,
            offset: props.popUpProps.offset,
            xAxisAnchor: props.popUpProps.xAxisAnchor,
            yAxisAnchor: props.popUpProps.yAxisAnchor,
            overlayClass: props.popUpProps.overlayClass,
            content: () => _jsx(SearchableListPopUp, { ...props })
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    inputRef = React.createRef();
    focusedItemRef = React.createRef();
    itemContainerRef = React.createRef();
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.itemsList = nextProps.itemList;
        return state;
    }
    componentDidMount() {
        this.inputRef.current?.focus();
    }
    componentDidUpdate() {
        if (!exists(this.state.focusedIndex))
            return;
        scrollIntoView(this.focusedItemRef, this.itemContainerRef);
    }
    // ######################### Logic #########################
    getItems = () => {
        if (!this.state.searchTerm)
            return this.state.itemsList;
        const filter = new Filter(item => [this.props.labelMapper(item)]);
        return filter.filter(this.state.itemsList, this.state.searchTerm);
    };
    onInputKeyDown = (e) => {
        if (!searchInteractionKeys.includes(e.key))
            return;
        stopPropagation(e);
        const currentItems = this.getItems();
        if (e.key === 'Enter') {
            if (!exists(this.state.focusedIndex))
                return;
            const selectedItem = currentItems[this.state.focusedIndex];
            return this.onItemSelected(selectedItem);
        }
        else {
            const itemCount = currentItems.length;
            if (itemCount === 0)
                return;
            //Start out the focused index as the current one
            let nextFocusedIndex = this.state.focusedIndex ?? (e.key === 'ArrowDown' ? 0 : itemCount - 1);
            //Increment / Decrement existing index
            if (exists(this.state.focusedIndex))
                nextFocusedIndex += (e.key === 'ArrowDown' ? 1 : -1);
            //Circular focus traversal
            if (nextFocusedIndex === -1)
                nextFocusedIndex = itemCount - 1;
            else if (nextFocusedIndex === itemCount)
                nextFocusedIndex = 0;
            this.setState({ focusedIndex: nextFocusedIndex });
        }
    };
    onItemSelected = async (item) => {
        await this.props.onItemSelected(item);
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
    };
    // ######################### Render #########################
    render() {
        return _jsxs(_Fragment, { children: [this.render_Search(), this.render_List()] });
    }
    render_Search = () => {
        return _jsx(LL_H_C, { className: 'searchable-list-popup__search', children: _jsx(TS_Input, { innerRef: this.inputRef, type: 'text', value: this.state.searchTerm, onChange: val => this.setState({ searchTerm: val, focusedIndex: undefined }), onKeyDown: this.onInputKeyDown, 
                //Keep focus on input always
                onBlur: () => this.inputRef.current?.focus() }) });
    };
    render_List = () => {
        const items = this.getItems();
        return _jsxs(LL_V_L, { className: 'searchable-list-popup__list', innerRef: this.itemContainerRef, children: [items.map(this.render_ListItem), !items.length && _jsx("div", { className: 'searchable-list-popup__item', children: "No items to show" })] });
    };
    render_ListItem = (item, index) => {
        const focused = index === this.state.focusedIndex;
        const className = _className('searchable-list-popup__item', focused && 'focused');
        const label = this.props.labelMapper(item);
        const key = `${label}-${index}`;
        return _jsx("div", { className: className, ref: focused ? this.focusedItemRef : undefined, onClick: () => this.onItemSelected(item), children: label }, key);
    };
}
//# sourceMappingURL=SearchableListPopUp.js.map